let products_on_page = $('#product-grid');
let next_url = products_on_page.data('next-url');
let lastProduct;

let observer = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if(entry.isIntersecting) {
      infiniteScroll();
    }
  })
}, {
  rootMargin: '0px 0px 0px 0px',
  threshold: 0.6
})

async function infiniteScroll() {
  try {
    const response = await fetch(next_url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Network response was not OK');
    }

    const next_page = await response.text();
    
    let new_products = $(next_page).find('#product-grid');
    let new_url = new_products.data('next-url');

    next_url = new_url;
    // console.log(next_url)
    products_on_page.append(new_products.html());

    // === START OF OBSERVER ===

    // Remove previous observers
    if (lastProduct) {
      observer.unobserve(lastProduct)
    }

    // Set new target
    const list = document.querySelectorAll("#product-grid > li")
    lastProduct = list[list.length - 1]

    // As long there is a 'next page' the Observer object will run 'infinteScroll()' function 
    if(next_url) {
      observer.observe(lastProduct)
    }

    // ==== END OF OBSERVER ====
  } catch (error) {
    console.error('Error:', error);
  }
}

if(next_url) {
  infiniteScroll();
}
